/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { toHeaderCase } from 'js-convert-case';
import config from "../config/portfolio.template.form.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import previewConfig from "../config/timelineSteps.config.json";
import { useCollection } from "../provider";
import { GET_PORTFOLIO_CREDENTIAL_SCHEMA } from "../graphql";

import { AppNavigatorService } from "../../appNavigatorService";

export interface IPortfolioFormMethods extends IPluginMethodMap {
    getPortfolioFormProps(args: any): Promise<any>;
}

const getWhoamiSrv = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.AppNavigatorService") as AppNavigatorService;
  };

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};


const dummydata = [
    {
      title: 'Recommendation',
      value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
    },
    {
      title: 'Feedback ',
      value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
    },
    {
      title: 'Goal',
      value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
    },
  ];

function isValidHttpUrl(string: string) {
    let url;

    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
}

export class PortfolioFormService implements IAgentPlugin {
    readonly methods: IPortfolioFormMethods;

    constructor() {
        this.methods = {
            getPortfolioFormProps: this.getProps.bind(this),
        };
    }

    async getProps(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        const { portfolioTempId } = useCollection();
        try {
            if (client) {
                const res = await client.query({
                    query: GET_PORTFOLIO_CREDENTIAL_SCHEMA,
                    variables: {
                        filter: {
                            uuid:portfolioTempId,
                            
                          }
                    },
                    fetchPolicy: "network-only",
                });
                if (res?.data) {
                    console.log("newTata",res?.data)
                    let collectionList =  this.getPortfolioCredentials(res?.data?.getStudenPortfolioPerCredSchema?.data )
                    return {
            
                        collection: {collectionList}, 
                        totalPages:res?.data?.getStudenPortfolioPerCredSchema?.totalPages,
                        totalCount:res?.data?.getStudenPortfolioPerCredSchema?.totalCount,
                        currentPage:res?.data?.getStudenPortfolioPerCredSchema?.currentPage,
                        // buttons: await this.formatProductActions(res?.data?.getDetailedNode),
                        // buttons: this.formatProductActions(res?.data?.getStudenPortfolioPerCredSchema?.data),
                        portfolioTempId:portfolioTempId,
                        profileCard: this.getPortfolioData(res?.data?.getStudenPortfolioPerCredSchema?.portfolio)
                    }
                }
            }

        } catch (err: any) {
            return err;
        }
    }

    private async getState(){
        const serv = getWhoamiSrv();
        const {action} = useCollection();
        console.log(`action in service`, action);
        let user = await serv?.whoAmI();
        if(user?.whoami === "admin" || user?.whoami ==="master admin" ){
            return ["REVIEW_REQUESTED"]
        }
        if(user?.whoami === "student" && action ==="review-requested"){
            return ["REVIEW_REQUESTED", "APPROVED", "REJECTED"]
        }
        if(user?.whoami === "student" && action ==="listed"){
            return ["SHOWCASED"]
        }
    }

    private getPortfolioCredentials(data:any){
        const { portfolioTempId } = useCollection();
        // let _portfolio = nodeData;
    //    console.log(`portfolio Data`, _portfolio);
        let _preview: any = [];
        Array.isArray(data) && data?.forEach((item: any) => {
            console.log("asdnjask",item)
            _preview.push({
                id: item?.id,
                title: item?.name,
                description: item?.description,
                image:item?.logo,
                catalogueType: 'catalogue',
            })
        });

        return _preview;
    }

    private formatName(name: string) {
        if (name) {
            return toHeaderCase(name);
        }
    }


    private getPortfolioData(data:any){
        console.log (data,"Asdwd")
            return {
         
                    profileCover: data?.bannerImage,
                    profilePicture:data?.logo,
                    fullName:toHeaderCase(data?.name),
                    description:data?.description,
                    reason:this.getReasonForReject(data),
                logoSrc: data?.logo,
                title: toHeaderCase(data?.name),
                subtitle:data?.subTitle,
                portfolioTempId:data?.templateRef,
                badgeTitle:data?.rejectionReason,
                badgeTitleBg:"danger",
                comments : this.accrodionDataFormat(data)
            }
        }

        private accrodionDataFormat(data :any){
            let _formatData = [];
            // if (data.feedback && data.goal && data.recommendation) {
            //     _formatData.push({ title: "Recommendation", value:data?.recommendation });
            //   }

              if(data?.recommendation){
                _formatData.push({title:"Recommendation", value:data?.recommendation});
              }
              if(data?.feedback){
                _formatData.push({title:"Feedback", value:data?.feedback});
              }
              if(data?.goal){
                _formatData.push({title:"Goal", value:data?.goal});
              }
              console.log("forororo",_formatData)
              return _formatData;
        }
    

    private getReasonForReject(portfolio:any){
        if(portfolio?.state === "REJECTED"){
            return portfolio?.rejectionReason
        }
        else return null;
    }

    private formatAttributes(credential?: any) {
        let _attributeData: any = [];
        let formatted: any = { ...(credential || {}) };
        if (formatted) {
            for (let key in formatted) {
                if (config?.credentialSubject?.blacklistedKeys?.includes(key)) {
                    delete formatted[key];
                }
            }
        }

        Object.entries(formatted).forEach(([key, value]) => {
            if(!Array.isArray(value)){
                _attributeData.push({
                    label: toHeaderCase(key ?? ""),
                    value: value,
                });
            }
            
        });
        return _attributeData;
    }

    private formatCarouselItems(credential: any) {
        let _docs: any = [];
        if (credential?.pdf) {
            const src = isValidHttpUrl(credential?.pdf)
                ? credential?.pdf
                : `data:application/pdf;base64,${credential?.pdf}`;
            _docs.push({
                type: "pdf",
                poster: credential?.logo,
                src: src,
                title: credential?.credentialName,
            });
        }
        Array.isArray(credential?.evidence) &&
            credential?.evidence.map((item: any) => {
                let _type = item?.evidenceDocumentType?.split("/");
                _docs.push({
                    type: _type[0] === "image" ? "img" : _type[0] === "video" ? "video" : _type[0] === "audio" ? "audio" : "pdf",
                    poster: item?.poster,
                    src: item?.id,
                    title: item?.evidenceDocument?.replace(/\.[^/.]+$/, ""),
                });
            });
        return _docs;
    }

    private  formatProductActions(data?: any) {
        // const { portfolioTempId } = useCollection();
        // let _portfolio = data?.node
        // const serv = getWhoamiSrv();
        // let user = await serv?.whoAmI();
        // const formatted: any = [];
        // if (_portfolio?.state === "REVIEW_REQUESTED" && (user?.whoami === "admin" || user?.whoami === "master admin") ) {
        //   formatted.push(config?.approveButton);
        //   formatted.push(config?.rejectButton);   
        // }
        // if (_portfolio?.state === "APPROVED" && (user?.whoami === "student")) {
        //     formatted.push(config?.showCaseButton);  
        // }
        // if(_portfolio?.state === "REJECTED" && (user?.whoami === "student")) {
        //     formatted.push(config?.editButton);    
        // }
        // if(_portfolio?.state === "SHOWCASED" && (user?.whoami === "student")) {
        //     formatted.push(config?.unListButton);    
        // }
            const formatted: any = [];
                      formatted.push(config?.approveButton);
          formatted.push(config?.rejectButton);  
        return formatted;
    }
}